import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate";
import encryptData from "../utils/encryptData";

const estimateStore = new Vuex.Store({
    state: {
        estimate: "",
        orderType: "",
        orderConfirm: false,
        isSaved: false
    },
    mutations:{
        updateDataFromMap(state, dataEstimateJSON) {
            state.estimate = encryptData.crypt(dataEstimateJSON)
        },
        updateOrderType(state, orderType) {
            state.orderType = orderType
        },
        resetEstimationStore(state) {
            state.estimate = ""
            state.orderType = ""
            state.orderConfirm = false
            state.isSaved = false

            localStorage.removeItem("estimate")
        },
        setOrderConfirm(state, orderConfirm) {
            state.orderConfirm = orderConfirm
        },
        setIsSaved(state, isSaved) {
            state.isSaved = isSaved
        }
    },
    plugins: [createPersistedState({
        key: "estimate"
    })],
})


export {
    estimateStore,
}